import React, { Fragment } from "react";
import "../css/workex.css";
import { Row, Col } from "react-bootstrap";
import project from "../img/Project Stages-bro.svg";
import { Box, Tab, Tabs, Typography } from "@material-ui/core";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div className="panel-div">
          <Typography>{children}</Typography>
        </div>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const Workex = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Fragment>
      <p className="side-text-workex">Experience</p>
      <h2 className="section-heading">
        Experience & Positions of Responsibility
      </h2>
      <h2 className="section-quote">"Every experience makes you grow"</h2>
      <hr className="hr-workex" />

      <Row>
        <Col lg={8} md={12} sm={12} xs={12}>
          <div className="workex-box">
            <Box
              sx={{
                display: "flex",
              }}
            >
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                sx={{ borderRight: 1, borderColor: "divider" }}
              >
                <Tab label="Hallparty Inc" {...a11yProps(0)} />
                <Tab label="Cruxe.in" {...a11yProps(1)} />
                {/* <Tab label="ACM Thapar" {...a11yProps(2)} /> */}
              </Tabs>
              <TabPanel value={value} index={0}>
                <div className="tabpanel-div">
                  <h4 className="workex-position">
                    Software Development Intern
                    <span>January 2022 - August 2022</span>
                  </h4>
                  <h5></h5>
                  <br></br>
                  <div>
                    <ul>
                      <li>
                        <span>Backend Development:</span> Leveraged typescript,
                        nodejs, and graphql to develop and maintain the
                        hallparty app and web client’s backend while supporting
                        more than 10,000 users
                      </li>
                      <li>
                        <span>Database Agnostic Architecture:</span> Implemented
                        a backend architecture that is database independent
                        increasing productivity by 30% and reducing database
                        dependency by more than 60%
                      </li>
                      <li>
                        <span>Serverless Environment:</span> Launched a
                        serverless environment for efficient use of AWS lambda
                        functions and Infrastructure As Code reducing the time
                        of development by 40%
                      </li>
                      <li>
                        <span>Code Refactoring:</span> Refactored the code to
                        improve developer experience by 50%
                      </li>
                    </ul>
                  </div>
                </div>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <div className="tabpanel-div">
                  <h4 className="workex-position">
                    Software Development Intern
                    <span>April 2021 - August 2021</span>
                  </h4>
                  <h5></h5>
                  <br></br>
                  <div>
                    <ul>
                      <li>
                        <span>Web Client Development: </span> Developed and
                        integrated Cruxe.in website using React and Redux from
                        scratch gathering 5000+ views in the first month.
                      </li>
                      <li>
                        <span>API Integration: </span> Co-ordinated with 4
                        departments on design, development and integration of
                        natural language processing model API in frontend.
                      </li>
                      <li>
                        <span>Impact:</span> Improved impact while gaining
                        experience with SEO, scalabilty and benchmark
                        evaluations and increased website discoverability rate
                        by atleast 25%
                      </li>
                    </ul>
                  </div>
                </div>
              </TabPanel>
            </Box>
          </div>
          {/* <section class="timeline">
        <div class="container">
<div class="timeline-item">
<div class="timeline-img"></div>

<div class="timeline-content">
  <h2>Intern</h2>
  <div class="date">April-August, 2021</div>
  <p>Internship as a frontend developer at Cruxeware Technologies</p>
</div>
</div>

<div class="timeline-item">
<div class="timeline-img"></div>
<div class="timeline-content">
  <h2>Joint Tech Head</h2>
  <div class="date">2021</div>
  <p>Joint Tech Head at ACM Thapar, a chapter of the international society of ACM at Thapar Institute of Engineering & Technology</p>
</div>
</div>

<div class="timeline-item">
<div class="timeline-img"></div>
<div class="timeline-content">
  <h2>Core Member</h2>
  <div class="date">2021</div>
  <p>Core member at Creative Computing Society in Thapar Institute of Engineering & Technology</p>
</div>
</div>

<div class="timeline-item">
<div class="timeline-img"></div>
<div class="timeline-content">
  <h2>Manager of Technical Affairs</h2>
  <div class="date">2021</div>
  <p>Manager of Technical Affairs at Thapar Toastmasters, a chapter of the international society of Toastmasters at Thapar Institute of Engineering & Technology</p>
</div>
</div>

</div>
</section> */}
        </Col>
        <Col xs={4}>
          <img src={project} className="project-img" alt="project-img" />
        </Col>
      </Row>
    </Fragment>
  );
};

export default Workex;
